import React from 'react'
import { Reefer, DryVan, DropTrailer, FlatBed, Specialized } from 'components/atoms/icons'
import PropTypes from 'prop-types'
import { EQUIPMENT } from 'constants/equipment'

export const findEquipmentIds = equipmentKey => {
  const equipmentElement = EQUIPMENT.find(element => element.key === equipmentKey)
  return equipmentElement.trailer_equipment_types
    .map(equipmentTypes => equipmentTypes.id)
    .concat(equipmentElement.id)
}

export const EQUIPMENT_ICON_MAP = [
  {
    ids: findEquipmentIds('dry_van'),
    key: 'dry_van',
    name: 'Dry Van',
    Icon: DryVan,
  },
  {
    ids: findEquipmentIds('reefer'),
    key: 'reefer',
    name: 'Reefer',
    Icon: Reefer,
  },
  {
    ids: findEquipmentIds('open_deck'),
    key: 'open_deck',
    name: 'Open Deck',
    Icon: FlatBed,
  },
  {
    ids: findEquipmentIds('specialized'),
    key: 'specialized',
    name: 'Specialized',
    Icon: Specialized,
  },
  {
    ids: findEquipmentIds('drop_trailer'),
    key: 'drop_trailer',
    name: 'Drop Trailer',
    Icon: DropTrailer,
  },
]

export const EquipmentTypeIcon = (props = {}) => {
  const { className, icon, id, tooltip, tooltipAlign } = props
  if (icon) {
    const equipmentObject = EQUIPMENT_ICON_MAP.find(e => icon === e.key) || {
      Icon: Specialized,
      name: 'Specialized',
    }
    const { Icon, name: parentEquipmentName } = equipmentObject
    const tooltipName = tooltip || parentEquipmentName
    return (
      <span data-tooltip={tooltipName} className={tooltipAlign ? `align-${tooltipAlign}` : ''}>
        <Icon className={className} />
      </span>
    )
  }
  const equipmentObject = EQUIPMENT_ICON_MAP.find(eq => {
    const { key } = eq
    const idList = findEquipmentIds(key)
    return idList.includes(id)
  })
  if (equipmentObject) {
    const { Icon, name } = equipmentObject
    return (
      <span data-tooltip={name} className={tooltipAlign ? `align-${tooltipAlign}` : ''}>
        <Icon className={className} />
      </span>
    )
  }
  return null
}

EquipmentTypeIcon.propTypes = {
  id: PropTypes.number,
  icon: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipAlign: PropTypes.string,
}
EquipmentTypeIcon.defaultProps = {
  id: 0,
  icon: '',
  className: 'icon',
  tooltip: '',
  tooltipAlign: '',
}

const listEquipmentIds = equipmentKey => {
  const equipmentElement = EQUIPMENT.find(element => element.key === equipmentKey)
  return equipmentElement.trailer_equipment_types
    .map(equipmentTypes => equipmentTypes.id)
    .concat(equipmentElement.id)
}

export const EquipmentIdToType = props => {
  if (!props.id) return ''
  const equipmentObject = EQUIPMENT.find(eq => {
    const { id, key } = eq
    const idList = listEquipmentIds(key)
    return id === props.id || idList.includes(props.id)
  })
  if (equipmentObject) return equipmentObject.key

  return 'specialized'
}

export const EquipmentIdToParentId = equipmentId => {
  if (!equipmentId) return ''
  const equipmentObject = EQUIPMENT.find(eq => {
    const { id, key } = eq
    const idList = listEquipmentIds(key)
    return id === equipmentId || idList.includes(equipmentId)
  })
  if (equipmentObject) return equipmentObject.id

  return 20
}
